/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */
/**
 * @module plugins/placeholder
 */
import { Config } from "../../config.js";
Config.prototype.showPlaceholder = true;
Config.prototype.placeholder = 'Type something';
Config.prototype.useInputsPlaceholder = true;
